export default __webpack_public_path__ + "static/media/play-button.dc236b09.svg";